import { parseDataAttributes } from '../../utilities/utilities'
import type { TypographyConfig } from '../../types/widget-types'

export type CartSummaryConfigStyles = {
  labelTypography: TypographyConfig
  priceTypography: TypographyConfig
}

export type CartSummaryAttributes = {
  showSubtotal?: boolean
  showShipping?: boolean
  showTax?: boolean
  showTotal?: boolean
  configStyles?: CartSummaryConfigStyles
}

export function getCartSummaryAttributes(attrs: NamedNodeMap): CartSummaryAttributes {
  const base = parseDataAttributes(attrs) as Record<string, unknown>

  const showSubtotal = base.showSubtotal === 'yes' || base.showSubtotal === true
  const showShipping = base.showShipping === 'yes' || base.showShipping === true
  const showTax = base.showTax === 'yes' || base.showTax === true
  const showTotal = base.showTotal === 'yes' || base.showTotal === true

  return {
    showSubtotal,
    showShipping,
    showTax,
    showTotal,
    configStyles: base.configStyles as CartSummaryConfigStyles | undefined,
  }
}

export default function propsFn(dataAttributes: NamedNodeMap): CartSummaryAttributes {
  return getCartSummaryAttributes(dataAttributes)
}
